import React from 'react'
// import CommonBanner
import CommonBanner from '../../component/Common/CommonBanner'
import Media from '../../component/Media'
import { ImageConstants } from '../../assets/img/ImageConstants'
// import AllFaqs




const UmrahMedia24 = () => {
  return (
    <>
      {/* <CommonBanner heading="Umrah" pagination="Media"/> */}
      <CommonBanner
        heading="Umrah"
         img={ImageConstants.umrahbanner}
        pagination="Media"
      />
      <Media/>
    
    </>
  )
}

export default UmrahMedia24